<style lang="scss" scoped>
.invalid-feedback {
  display: block;
}
</style>

<template>
  <div>
    <div class="btn-group">
      <button type="button" class="btn" @click="addMessage()">
        {{ buttonText }}
      </button>
    </div>
    <div
      class="d-flex form-group"
      v-for="(element, index) in elements"
      :key="element.type + '-' + index"
    >
      <input
        class="w-100 mr-2 d-flex flex-column justify-content-center form-control"
        v-model="element.value"
        @input="emitValue"
        :attributeErrors="element.errors"
        :index="index"
      />
      <button
        v-if="element.type !== 'pause'"
        type="button"
        class="btn btn-danger align-self-start mt-0"
        @click="removeElement(index)"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div
      v-for="error in attribute.errors"
      :key="error"
      class="invalid-feedback"
    >
      {{ error }}
    </div>
  </div>
</template>

<script lang="babel">

export default {
  props: {
    value: {
      required: true,
    },
    attribute: {
      required: true,
      type: Object,
    }
  },
  data() {
    return {
      elements: [],
      types: {
        text: 'Text'
      }
    };
  },
  created() {
    this.$bus.$on('resource-persisted', () => {
      this.elements = [];
    });
  },
  mounted() {
    this.setupNestedErrors();
    this.setupElements();
  },
  computed: {
    nestedErrors() {
      return this.attribute.nestedErrors;
    },
    buttonText() {
      return this.attribute.buttonText || '+Wort';
    }
  },
  methods: {
    setupElements() {
      if (!this.value) {
        return;
      }

      this.value.forEach(message => {
        let value;
        value = message.value;

        this.elements.push({
          value: value,
          errors: []
        });
      });
    },
    addMessage() {
      this.elements.push({
        value: null,
        errors: []
      });
    },
    removeElement(index) {
      let fromIndex = index;
      if (index === this.elements.length - 1) {
        fromIndex = index - 1;
      }
      this.elements.splice(fromIndex, 1);
    },
    emitValue() {
      this.$emit("input", this.elements);
    },
    setupNestedErrors() {
      this.elements.forEach(element => {
        element.errors = [];
      });

      Object.keys(this.nestedErrors).forEach(errorKey => {
        let nestedKeys = errorKey.split(".");
        let index = nestedKeys[0];
        let errorArray = [];
        this.nestedErrors[errorKey].forEach(error => {
          if (Array.isArray(error)) {
            errorArray.push(error);
          } else {
            errorArray.push([error]);
          }
        });
        this.$set(this.elements[index], 'errors', this.elements[index].errors.concat(errorArray));
      });
    }
  },
  watch: {
    elements: {
      handler: function() {
        this.emitValue();
      },
      deep: true
    },
    nestedErrors() {
      this.setupNestedErrors();
    }
  }
}
</script>
